/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import apiService from '../../axios/apiService';
import PropTypes from 'prop-types';
import UserForm from './UserForm';

const EditUser = forwardRef(function EditUser(
  { formValues, onSuccess, onError },
  ref
) {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      reset: formRef?.current?.reset // eslint-disable-line no-unused-labels
    }),
    []
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await apiService.updateStaff({
        userSub: data?.userSub,
        status: data?.status,
        modules: data?.modules,
      });
      setLoading(false);
      onSuccess?.(response);
    } catch (error) {
      setLoading(false);
      onError?.(error);
    }
  };

  return (
    <UserForm
      formValues={formValues}
      onSubmit={onSubmit}
      loading={loading}
      ref={formRef}
      isEdit
    />
  );
});

EditUser.propTypes = {
  formValues: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default EditUser;
